import type { ExternalToast } from 'sonner';

import { linkActionLabel, type MissingHost } from '@/features/identity';

import type { MoveRefusal } from './errors';

/**
 * The toast's options for a refused start: an action to the Linked accounts
 * panel when the person's own account is what is missing; nothing otherwise,
 * so every other refusal reads exactly as before.
 */
export function refusalToastOptions(
  refusal: Pick<MoveRefusal, 'kind'> & { hosts?: readonly MissingHost[] },
  openLinkedAccounts: () => void,
): ExternalToast | undefined {
  if (refusal.kind !== 'needs-account' || !refusal.hosts) return undefined;
  return {
    action: {
      label: linkActionLabel(refusal.hosts),
      onClick: openLinkedAccounts,
    },
  };
}
